import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['section'];
  static values = { confirmationId: String, modalId: String };

  sectionTargetConnected(section) {
    this.setFieldsDisabled(section, section.classList.contains('hidden'));
  }

  accept() {
    this.openModal(false);
  }

  decline() {
    this.openModal(true);
  }

  openModal(raiseQuery) {
    this.sectionTargets.forEach((section) => {
      section.classList.toggle('hidden', !raiseQuery);
      this.setFieldsDisabled(section, !raiseQuery);
    });
    this.dispatch('close', {
      prefix: 'local-modal-manager',
      detail: { id: this.confirmationIdValue },
    });
    this.dispatch('open', { prefix: 'local-modal-manager', detail: { id: this.modalIdValue } });
  }

  setFieldsDisabled(section, disabled) {
    section.querySelectorAll('input, select, textarea, button').forEach((field) => {
      field.disabled = disabled;
    });
  }
}
